import { useEffect } from 'react';
import { TableProps } from '../use-table';
import { TreeItems } from 'dnd-kit-sortable-tree';
import { TableColumnWidgetItemProps } from './table-column-widget-item/use-table-column-widget-item';
import { useLocalStorageSubscribe } from '../../../hooks/use-local-storage-subscribe';

interface Props extends Pick<TableProps, 'cols'> {
  id: string;
}

export const useTableColumnWidget = (props: Props) => {
  const { cols = {}, id } = props;

  const { handleChange } = useLocalStorageSubscribe();

  let treeCols: TreeItems<TableColumnWidgetItemProps> = Object.keys(cols).map((key) => ({
    id: key,
    columnId: key,
    label: cols[key].label as string,
    tableId: props.id,
  }));

  const sortExample = localStorage.getItem(`${id}-sort`);
  
  if (sortExample) {
    const sortOrder: string[] = JSON.parse(sortExample);
    treeCols = treeCols.sort((a, b) => {
      const indexA = sortOrder.indexOf(a.columnId);
      const indexB = sortOrder.indexOf(b.columnId);
      return indexA - indexB;
    });
  }

  useEffect(() => {
    if (!localStorage.getItem(id)) {
      const newSettings: Record<string, boolean> = {};
      Object.keys(cols).forEach((key) => (newSettings[key] = true));
      localStorage.setItem(id, JSON.stringify(newSettings));
      handleChange();
    }
  }, []);

  const handleChangeSort = (items: TableColumnWidgetItemProps[]) => {
    localStorage.setItem(`${id}-sort`, JSON.stringify(items.map((item) => item.columnId)));
    handleChange();
  };

  return {
    treeCols,
    handleChangeSort,
  };
};
